// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__W_76s"};